import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='text-3xl'>Contact Us: rohanrafat35@gmail.com</h1>
        </div>
    );
};

export default About;